import React, { memo, useState } from 'react';
import { LuSplitSquareHorizontal } from 'react-icons/lu';
import { MdModeEditOutline, MdOutlineDeleteOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import ContainerTitle from '../shared/container/ContainerTitle';
import DeleteVisitModal from './modals/DeleteVisitModal';
import UpdateVisitModal from './modals/UpdateVisitModal';
import SplitVisit from './split/SplitVisit';

const VisitsHeader = ({ readOnly }) => {
  const [showUpdateVisitModal, setShowUpdateVisitModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSplitModal, setShowSplitModal] = useState(false);
  const visitTasks = useSelector((state) => state.visitTasks.visitTasks);
  const visitParts = useSelector((state) => state.visitParts.visitParts);
  const handleVisitModalSubmit = async () => {
    setShowUpdateVisitModal(false);
  };

  return (
    <ContainerHeader>
      {showSplitModal && <SplitVisit onModalClose={() => setShowSplitModal(false)} />}
      {showUpdateVisitModal && (
        <UpdateVisitModal
          onModalSubmit={() => handleVisitModalSubmit()}
          onModalClose={() => setShowUpdateVisitModal(false)}
        />
      )}
      {showDeleteModal && <DeleteVisitModal onModalClose={() => setShowDeleteModal(false)} />}
      <ContainerTitle title={'Загальна інформація'} />
      <div className="flex gap-2 items-center">
        {!readOnly && (
          <>
            <Button variant={'action2'} onClick={() => setShowDeleteModal(true)}>
              <MdOutlineDeleteOutline size={20} />
            </Button>
            {(visitTasks.length !== 0 || visitParts.length !== 0) && (
              <Button variant={'action2'} onClick={() => setShowSplitModal(true)}>
                <LuSplitSquareHorizontal size={20} />
              </Button>
            )}
            <Button variant={'action2'} onClick={() => setShowUpdateVisitModal(true)}>
              <MdModeEditOutline size={20} />
            </Button>
          </>
        )}
      </div>
    </ContainerHeader>
  );
};

export default memo(VisitsHeader);
